import React from "react";
import { Navigate, useLocation } from "react-router";

export function RedirectKeepingQuery({ to }: { to: string }): React.ReactElement {
  const { search, hash } = useLocation();
  return <Navigate to={{ pathname: to, search, hash }} replace />;
}
